var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"content"},[_c('div',{staticClass:"text-content"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"thank-you"},[_c('h1',[_vm._v("Thank You!")]),_c('h3',[_vm._v("Document has been successfully signed. You can close this window now.")])])])])])
}]

export { render, staticRenderFns }